import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { TransactionNotStartedError } from "../../error/TransactionNotStartedError";
import { TableColumn } from "../../schema-builder/table/TableColumn";
import { Table } from "../../schema-builder/table/Table";
import { TableIndex } from "../../schema-builder/table/TableIndex";
import { TableForeignKey } from "../../schema-builder/table/TableForeignKey";
import { View } from "../../schema-builder/view/View";
import { Query } from "../Query";
import { TableUnique } from "../../schema-builder/table/TableUnique";
import { BaseQueryRunner } from "../../query-runner/BaseQueryRunner";
import { OrmUtils } from "../../util/OrmUtils";
import { TableCheck } from "../../schema-builder/table/TableCheck";
import { TransactionAlreadyStartedError, TypeORMError } from "../../error";
import { MetadataTableType } from "../types/MetadataTableType";
import { InstanceChecker } from "../../util/InstanceChecker";
/**
 * Runs queries on a single sqlite database connection.
 */
export var AbstractSqliteQueryRunner = /*#__PURE__*/function (_BaseQueryRunner) {
  _inherits(AbstractSqliteQueryRunner, _BaseQueryRunner);
  var _super = _createSuper(AbstractSqliteQueryRunner);
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function AbstractSqliteQueryRunner() {
    var _this;
    _classCallCheck(this, AbstractSqliteQueryRunner);
    _this = _super.call(this);
    _this.transactionPromise = null;
    return _this;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Creates/uses database connection from the connection pool to perform further operations.
   * Returns obtained database connection.
   */
  _createClass(AbstractSqliteQueryRunner, [{
    key: "connect",
    value: function connect() {
      return Promise.resolve(this.driver.databaseConnection);
    }
    /**
     * Releases used database connection.
     * We just clear loaded tables and sql in memory, because sqlite do not support multiple connections thus query runners.
     */
  }, {
    key: "release",
    value: function release() {
      this.loadedTables = [];
      this.clearSqlMemory();
      return Promise.resolve();
    }
    /**
     * Starts transaction.
     */
  }, {
    key: "startTransaction",
    value: function () {
      var _startTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(isolationLevel) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.driver.transactionSupport === "none")) {
                _context.next = 2;
                break;
              }
              throw new TypeORMError("Transactions aren't supported by ".concat(this.connection.driver.options.type, "."));
            case 2:
              if (!(this.isTransactionActive && this.driver.transactionSupport === "simple")) {
                _context.next = 4;
                break;
              }
              throw new TransactionAlreadyStartedError();
            case 4:
              if (!(isolationLevel && isolationLevel !== "READ UNCOMMITTED" && isolationLevel !== "SERIALIZABLE")) {
                _context.next = 6;
                break;
              }
              throw new TypeORMError("SQLite only supports SERIALIZABLE and READ UNCOMMITTED isolation");
            case 6:
              this.isTransactionActive = true;
              _context.prev = 7;
              _context.next = 10;
              return this.broadcaster.broadcast("BeforeTransactionStart");
            case 10:
              _context.next = 16;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](7);
              this.isTransactionActive = false;
              throw _context.t0;
            case 16:
              if (!(this.transactionDepth === 0)) {
                _context.next = 29;
                break;
              }
              if (!isolationLevel) {
                _context.next = 25;
                break;
              }
              if (!(isolationLevel === "READ UNCOMMITTED")) {
                _context.next = 23;
                break;
              }
              _context.next = 21;
              return this.query("PRAGMA read_uncommitted = true");
            case 21:
              _context.next = 25;
              break;
            case 23:
              _context.next = 25;
              return this.query("PRAGMA read_uncommitted = false");
            case 25:
              _context.next = 27;
              return this.query("BEGIN TRANSACTION");
            case 27:
              _context.next = 31;
              break;
            case 29:
              _context.next = 31;
              return this.query("SAVEPOINT typeorm_".concat(this.transactionDepth));
            case 31:
              this.transactionDepth += 1;
              _context.next = 34;
              return this.broadcaster.broadcast("AfterTransactionStart");
            case 34:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[7, 12]]);
      }));
      function startTransaction(_x) {
        return _startTransaction.apply(this, arguments);
      }
      return startTransaction;
    }()
    /**
     * Commits transaction.
     * Error will be thrown if transaction was not started.
     */
  }, {
    key: "commitTransaction",
    value: function () {
      var _commitTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.isTransactionActive) {
                _context2.next = 2;
                break;
              }
              throw new TransactionNotStartedError();
            case 2:
              _context2.next = 4;
              return this.broadcaster.broadcast("BeforeTransactionCommit");
            case 4:
              if (!(this.transactionDepth > 1)) {
                _context2.next = 9;
                break;
              }
              _context2.next = 7;
              return this.query("RELEASE SAVEPOINT typeorm_".concat(this.transactionDepth - 1));
            case 7:
              _context2.next = 12;
              break;
            case 9:
              _context2.next = 11;
              return this.query("COMMIT");
            case 11:
              this.isTransactionActive = false;
            case 12:
              this.transactionDepth -= 1;
              _context2.next = 15;
              return this.broadcaster.broadcast("AfterTransactionCommit");
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function commitTransaction() {
        return _commitTransaction.apply(this, arguments);
      }
      return commitTransaction;
    }()
    /**
     * Rollbacks transaction.
     * Error will be thrown if transaction was not started.
     */
  }, {
    key: "rollbackTransaction",
    value: function () {
      var _rollbackTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.isTransactionActive) {
                _context3.next = 2;
                break;
              }
              throw new TransactionNotStartedError();
            case 2:
              _context3.next = 4;
              return this.broadcaster.broadcast("BeforeTransactionRollback");
            case 4:
              if (!(this.transactionDepth > 1)) {
                _context3.next = 9;
                break;
              }
              _context3.next = 7;
              return this.query("ROLLBACK TO SAVEPOINT typeorm_".concat(this.transactionDepth - 1));
            case 7:
              _context3.next = 12;
              break;
            case 9:
              _context3.next = 11;
              return this.query("ROLLBACK");
            case 11:
              this.isTransactionActive = false;
            case 12:
              this.transactionDepth -= 1;
              _context3.next = 15;
              return this.broadcaster.broadcast("AfterTransactionRollback");
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function rollbackTransaction() {
        return _rollbackTransaction.apply(this, arguments);
      }
      return rollbackTransaction;
    }()
    /**
     * Returns raw data stream.
     */
  }, {
    key: "stream",
    value: function stream(query, parameters, onEnd, onError) {
      throw new TypeORMError("Stream is not supported by sqlite driver.");
    }
    /**
     * Returns all available database names including system databases.
     */
  }, {
    key: "getDatabases",
    value: function () {
      var _getDatabases = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", Promise.resolve([]));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function getDatabases() {
        return _getDatabases.apply(this, arguments);
      }
      return getDatabases;
    }()
    /**
     * Returns all available schema names including system schemas.
     * If database parameter specified, returns schemas of that database.
     */
  }, {
    key: "getSchemas",
    value: function () {
      var _getSchemas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(database) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", Promise.resolve([]));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function getSchemas(_x2) {
        return _getSchemas.apply(this, arguments);
      }
      return getSchemas;
    }()
    /**
     * Checks if database with the given name exist.
     */
  }, {
    key: "hasDatabase",
    value: function () {
      var _hasDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(database) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", Promise.resolve(false));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function hasDatabase(_x3) {
        return _hasDatabase.apply(this, arguments);
      }
      return hasDatabase;
    }()
    /**
     * Loads currently using database
     */
  }, {
    key: "getCurrentDatabase",
    value: function () {
      var _getCurrentDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", Promise.resolve(undefined));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function getCurrentDatabase() {
        return _getCurrentDatabase.apply(this, arguments);
      }
      return getCurrentDatabase;
    }()
    /**
     * Checks if schema with the given name exist.
     */
  }, {
    key: "hasSchema",
    value: function () {
      var _hasSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(schema) {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              throw new TypeORMError("This driver does not support table schemas");
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function hasSchema(_x4) {
        return _hasSchema.apply(this, arguments);
      }
      return hasSchema;
    }()
    /**
     * Loads currently using database schema
     */
  }, {
    key: "getCurrentSchema",
    value: function () {
      var _getCurrentSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", Promise.resolve(undefined));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function getCurrentSchema() {
        return _getCurrentSchema.apply(this, arguments);
      }
      return getCurrentSchema;
    }()
    /**
     * Checks if table with the given name exist in the database.
     */
  }, {
    key: "hasTable",
    value: function () {
      var _hasTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(tableOrName) {
        var tableName, sql, result;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              tableName = InstanceChecker.isTable(tableOrName) ? tableOrName.name : tableOrName;
              sql = "SELECT * FROM \"sqlite_master\" WHERE \"type\" = 'table' AND \"name\" = '".concat(tableName, "'");
              _context10.next = 4;
              return this.query(sql);
            case 4:
              result = _context10.sent;
              return _context10.abrupt("return", result.length ? true : false);
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function hasTable(_x5) {
        return _hasTable.apply(this, arguments);
      }
      return hasTable;
    }()
    /**
     * Checks if column with the given name exist in the given table.
     */
  }, {
    key: "hasColumn",
    value: function () {
      var _hasColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(tableOrName, columnName) {
        var tableName, sql, columns;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              tableName = InstanceChecker.isTable(tableOrName) ? tableOrName.name : tableOrName;
              sql = "PRAGMA table_xinfo(".concat(this.escapePath(tableName), ")");
              _context11.next = 4;
              return this.query(sql);
            case 4:
              columns = _context11.sent;
              return _context11.abrupt("return", !!columns.find(function (column) {
                return column["name"] === columnName;
              }));
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function hasColumn(_x6, _x7) {
        return _hasColumn.apply(this, arguments);
      }
      return hasColumn;
    }()
    /**
     * Creates a new database.
     */
  }, {
    key: "createDatabase",
    value: function () {
      var _createDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(database, ifNotExist) {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", Promise.resolve());
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      function createDatabase(_x8, _x9) {
        return _createDatabase.apply(this, arguments);
      }
      return createDatabase;
    }()
    /**
     * Drops database.
     */
  }, {
    key: "dropDatabase",
    value: function () {
      var _dropDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(database, ifExist) {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", Promise.resolve());
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      function dropDatabase(_x10, _x11) {
        return _dropDatabase.apply(this, arguments);
      }
      return dropDatabase;
    }()
    /**
     * Creates a new table schema.
     */
  }, {
    key: "createSchema",
    value: function () {
      var _createSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(schemaPath, ifNotExist) {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", Promise.resolve());
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      function createSchema(_x12, _x13) {
        return _createSchema.apply(this, arguments);
      }
      return createSchema;
    }()
    /**
     * Drops table schema.
     */
  }, {
    key: "dropSchema",
    value: function () {
      var _dropSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(schemaPath, ifExist) {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", Promise.resolve());
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      function dropSchema(_x14, _x15) {
        return _dropSchema.apply(this, arguments);
      }
      return dropSchema;
    }()
    /**
     * Creates a new table.
     */
  }, {
    key: "createTable",
    value: function () {
      var _createTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(table) {
        var _this2 = this;
        var ifNotExist,
          createForeignKeys,
          createIndices,
          upQueries,
          downQueries,
          isTableExist,
          generatedColumns,
          _iterator,
          _step,
          column,
          insertQuery,
          deleteQuery,
          _args16 = arguments;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              ifNotExist = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : false;
              createForeignKeys = _args16.length > 2 && _args16[2] !== undefined ? _args16[2] : true;
              createIndices = _args16.length > 3 && _args16[3] !== undefined ? _args16[3] : true;
              upQueries = [];
              downQueries = [];
              if (!ifNotExist) {
                _context16.next = 11;
                break;
              }
              _context16.next = 8;
              return this.hasTable(table);
            case 8:
              isTableExist = _context16.sent;
              if (!isTableExist) {
                _context16.next = 11;
                break;
              }
              return _context16.abrupt("return", Promise.resolve());
            case 11:
              upQueries.push(this.createTableSql(table, createForeignKeys));
              downQueries.push(this.dropTableSql(table));
              if (createIndices) {
                table.indices.forEach(function (index) {
                  // new index may be passed without name. In this case we generate index name manually.
                  if (!index.name) index.name = _this2.connection.namingStrategy.indexName(table, index.columnNames, index.where);
                  upQueries.push(_this2.createIndexSql(table, index));
                  downQueries.push(_this2.dropIndexSql(index));
                });
              }
              // if table have column with generated type, we must add the expression to the metadata table
              generatedColumns = table.columns.filter(function (column) {
                return column.generatedType && column.asExpression;
              });
              _iterator = _createForOfIteratorHelper(generatedColumns);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  column = _step.value;
                  insertQuery = this.insertTypeormMetadataSql({
                    table: table.name,
                    type: MetadataTableType.GENERATED_COLUMN,
                    name: column.name,
                    value: column.asExpression
                  });
                  deleteQuery = this.deleteTypeormMetadataSql({
                    table: table.name,
                    type: MetadataTableType.GENERATED_COLUMN,
                    name: column.name
                  });
                  upQueries.push(insertQuery);
                  downQueries.push(deleteQuery);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context16.next = 19;
              return this.executeQueries(upQueries, downQueries);
            case 19:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function createTable(_x16) {
        return _createTable.apply(this, arguments);
      }
      return createTable;
    }()
    /**
     * Drops the table.
     */
  }, {
    key: "dropTable",
    value: function () {
      var _dropTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(tableOrName, ifExist) {
        var _this3 = this;
        var dropForeignKeys,
          dropIndices,
          isTableExist,
          createForeignKeys,
          table,
          upQueries,
          downQueries,
          generatedColumns,
          _iterator2,
          _step2,
          column,
          deleteQuery,
          insertQuery,
          _args17 = arguments;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              dropForeignKeys = _args17.length > 2 && _args17[2] !== undefined ? _args17[2] : true;
              dropIndices = _args17.length > 3 && _args17[3] !== undefined ? _args17[3] : true;
              if (!ifExist) {
                _context17.next = 8;
                break;
              }
              _context17.next = 5;
              return this.hasTable(tableOrName);
            case 5:
              isTableExist = _context17.sent;
              if (isTableExist) {
                _context17.next = 8;
                break;
              }
              return _context17.abrupt("return", Promise.resolve());
            case 8:
              // if dropTable called with dropForeignKeys = true, we must create foreign keys in down query.
              createForeignKeys = dropForeignKeys;
              if (!InstanceChecker.isTable(tableOrName)) {
                _context17.next = 13;
                break;
              }
              _context17.t0 = tableOrName;
              _context17.next = 16;
              break;
            case 13:
              _context17.next = 15;
              return this.getCachedTable(tableOrName);
            case 15:
              _context17.t0 = _context17.sent;
            case 16:
              table = _context17.t0;
              upQueries = [];
              downQueries = [];
              if (dropIndices) {
                table.indices.forEach(function (index) {
                  upQueries.push(_this3.dropIndexSql(index));
                  downQueries.push(_this3.createIndexSql(table, index));
                });
              }
              upQueries.push(this.dropTableSql(table, ifExist));
              downQueries.push(this.createTableSql(table, createForeignKeys));
              // if table had columns with generated type, we must remove the expression from the metadata table
              generatedColumns = table.columns.filter(function (column) {
                return column.generatedType && column.asExpression;
              });
              _iterator2 = _createForOfIteratorHelper(generatedColumns);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  column = _step2.value;
                  deleteQuery = this.deleteTypeormMetadataSql({
                    table: table.name,
                    type: MetadataTableType.GENERATED_COLUMN,
                    name: column.name
                  });
                  insertQuery = this.insertTypeormMetadataSql({
                    table: table.name,
                    type: MetadataTableType.GENERATED_COLUMN,
                    name: column.name,
                    value: column.asExpression
                  });
                  upQueries.push(deleteQuery);
                  downQueries.push(insertQuery);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _context17.next = 27;
              return this.executeQueries(upQueries, downQueries);
            case 27:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function dropTable(_x17, _x18) {
        return _dropTable.apply(this, arguments);
      }
      return dropTable;
    }()
    /**
     * Creates a new view.
     */
  }, {
    key: "createView",
    value: function () {
      var _createView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(view) {
        var syncWithMetadata,
          upQueries,
          downQueries,
          _args18 = arguments;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              syncWithMetadata = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : false;
              upQueries = [];
              downQueries = [];
              upQueries.push(this.createViewSql(view));
              if (syncWithMetadata) upQueries.push(this.insertViewDefinitionSql(view));
              downQueries.push(this.dropViewSql(view));
              if (syncWithMetadata) downQueries.push(this.deleteViewDefinitionSql(view));
              _context18.next = 9;
              return this.executeQueries(upQueries, downQueries);
            case 9:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function createView(_x19) {
        return _createView.apply(this, arguments);
      }
      return createView;
    }()
    /**
     * Drops the view.
     */
  }, {
    key: "dropView",
    value: function () {
      var _dropView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(target) {
        var viewName, view, upQueries, downQueries;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              viewName = InstanceChecker.isView(target) ? target.name : target;
              _context19.next = 3;
              return this.getCachedView(viewName);
            case 3:
              view = _context19.sent;
              upQueries = [];
              downQueries = [];
              upQueries.push(this.deleteViewDefinitionSql(view));
              upQueries.push(this.dropViewSql(view));
              downQueries.push(this.insertViewDefinitionSql(view));
              downQueries.push(this.createViewSql(view));
              _context19.next = 12;
              return this.executeQueries(upQueries, downQueries);
            case 12:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function dropView(_x20) {
        return _dropView.apply(this, arguments);
      }
      return dropView;
    }()
    /**
     * Renames the given table.
     */
  }, {
    key: "renameTable",
    value: function () {
      var _renameTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(oldTableOrName, newTableName) {
        var _this4 = this;
        var oldTable, newTable, up, down;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (!InstanceChecker.isTable(oldTableOrName)) {
                _context20.next = 4;
                break;
              }
              _context20.t0 = oldTableOrName;
              _context20.next = 7;
              break;
            case 4:
              _context20.next = 6;
              return this.getCachedTable(oldTableOrName);
            case 6:
              _context20.t0 = _context20.sent;
            case 7:
              oldTable = _context20.t0;
              newTable = oldTable.clone();
              newTable.name = newTableName;
              // rename table
              up = new Query("ALTER TABLE ".concat(this.escapePath(oldTable.name), " RENAME TO ").concat(this.escapePath(newTableName)));
              down = new Query("ALTER TABLE ".concat(this.escapePath(newTableName), " RENAME TO ").concat(this.escapePath(oldTable.name)));
              _context20.next = 14;
              return this.executeQueries(up, down);
            case 14:
              // rename unique constraints
              newTable.uniques.forEach(function (unique) {
                var oldUniqueName = _this4.connection.namingStrategy.uniqueConstraintName(oldTable, unique.columnNames);
                // Skip renaming if Unique has user defined constraint name
                if (unique.name !== oldUniqueName) return;
                unique.name = _this4.connection.namingStrategy.uniqueConstraintName(newTable, unique.columnNames);
              });
              // rename foreign key constraints
              newTable.foreignKeys.forEach(function (foreignKey) {
                var oldForeignKeyName = _this4.connection.namingStrategy.foreignKeyName(oldTable, foreignKey.columnNames, _this4.getTablePath(foreignKey), foreignKey.referencedColumnNames);
                // Skip renaming if foreign key has user defined constraint name
                if (foreignKey.name !== oldForeignKeyName) return;
                foreignKey.name = _this4.connection.namingStrategy.foreignKeyName(newTable, foreignKey.columnNames, _this4.getTablePath(foreignKey), foreignKey.referencedColumnNames);
              });
              // rename indices
              newTable.indices.forEach(function (index) {
                var oldIndexName = _this4.connection.namingStrategy.indexName(oldTable, index.columnNames, index.where);
                // Skip renaming if Index has user defined constraint name
                if (index.name !== oldIndexName) return;
                index.name = _this4.connection.namingStrategy.indexName(newTable, index.columnNames, index.where);
              });
              // rename old table;
              oldTable.name = newTable.name;
              // recreate table with new constraint names
              _context20.next = 20;
              return this.recreateTable(newTable, oldTable);
            case 20:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function renameTable(_x21, _x22) {
        return _renameTable.apply(this, arguments);
      }
      return renameTable;
    }()
    /**
     * Creates a new column from the column in the table.
     */
  }, {
    key: "addColumn",
    value: function () {
      var _addColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(tableOrName, column) {
        var table;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context21.next = 4;
                break;
              }
              _context21.t0 = tableOrName;
              _context21.next = 7;
              break;
            case 4:
              _context21.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context21.t0 = _context21.sent;
            case 7:
              table = _context21.t0;
              return _context21.abrupt("return", this.addColumns(table, [column]));
            case 9:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function addColumn(_x23, _x24) {
        return _addColumn.apply(this, arguments);
      }
      return addColumn;
    }()
    /**
     * Creates a new columns from the column in the table.
     */
  }, {
    key: "addColumns",
    value: function () {
      var _addColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(tableOrName, columns) {
        var table, changedTable;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context22.next = 4;
                break;
              }
              _context22.t0 = tableOrName;
              _context22.next = 7;
              break;
            case 4:
              _context22.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context22.t0 = _context22.sent;
            case 7:
              table = _context22.t0;
              changedTable = table.clone();
              columns.forEach(function (column) {
                return changedTable.addColumn(column);
              });
              _context22.next = 12;
              return this.recreateTable(changedTable, table);
            case 12:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function addColumns(_x25, _x26) {
        return _addColumns.apply(this, arguments);
      }
      return addColumns;
    }()
    /**
     * Renames column in the given table.
     */
  }, {
    key: "renameColumn",
    value: function () {
      var _renameColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(tableOrName, oldTableColumnOrName, newTableColumnOrName) {
        var table, oldColumn, newColumn;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context23.next = 4;
                break;
              }
              _context23.t0 = tableOrName;
              _context23.next = 7;
              break;
            case 4:
              _context23.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context23.t0 = _context23.sent;
            case 7:
              table = _context23.t0;
              oldColumn = InstanceChecker.isTableColumn(oldTableColumnOrName) ? oldTableColumnOrName : table.columns.find(function (c) {
                return c.name === oldTableColumnOrName;
              });
              if (oldColumn) {
                _context23.next = 11;
                break;
              }
              throw new TypeORMError("Column \"".concat(oldTableColumnOrName, "\" was not found in the \"").concat(table.name, "\" table."));
            case 11:
              newColumn = undefined;
              if (InstanceChecker.isTableColumn(newTableColumnOrName)) {
                newColumn = newTableColumnOrName;
              } else {
                newColumn = oldColumn.clone();
                newColumn.name = newTableColumnOrName;
              }
              return _context23.abrupt("return", this.changeColumn(table, oldColumn, newColumn));
            case 14:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function renameColumn(_x27, _x28, _x29) {
        return _renameColumn.apply(this, arguments);
      }
      return renameColumn;
    }()
    /**
     * Changes a column in the table.
     */
  }, {
    key: "changeColumn",
    value: function () {
      var _changeColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(tableOrName, oldTableColumnOrName, newColumn) {
        var table, oldColumn;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context24.next = 4;
                break;
              }
              _context24.t0 = tableOrName;
              _context24.next = 7;
              break;
            case 4:
              _context24.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context24.t0 = _context24.sent;
            case 7:
              table = _context24.t0;
              oldColumn = InstanceChecker.isTableColumn(oldTableColumnOrName) ? oldTableColumnOrName : table.columns.find(function (c) {
                return c.name === oldTableColumnOrName;
              });
              if (oldColumn) {
                _context24.next = 11;
                break;
              }
              throw new TypeORMError("Column \"".concat(oldTableColumnOrName, "\" was not found in the \"").concat(table.name, "\" table."));
            case 11:
              _context24.next = 13;
              return this.changeColumns(table, [{
                oldColumn: oldColumn,
                newColumn: newColumn
              }]);
            case 13:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function changeColumn(_x30, _x31, _x32) {
        return _changeColumn.apply(this, arguments);
      }
      return changeColumn;
    }()
    /**
     * Changes a column in the table.
     * Changed column looses all its keys in the db.
     */
  }, {
    key: "changeColumns",
    value: function () {
      var _changeColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(tableOrName, changedColumns) {
        var _this5 = this;
        var table, changedTable;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context25.next = 4;
                break;
              }
              _context25.t0 = tableOrName;
              _context25.next = 7;
              break;
            case 4:
              _context25.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context25.t0 = _context25.sent;
            case 7:
              table = _context25.t0;
              changedTable = table.clone();
              changedColumns.forEach(function (changedColumnSet) {
                if (changedColumnSet.newColumn.name !== changedColumnSet.oldColumn.name) {
                  changedTable.findColumnUniques(changedColumnSet.oldColumn).forEach(function (unique) {
                    var uniqueName = _this5.connection.namingStrategy.uniqueConstraintName(table, unique.columnNames);
                    unique.columnNames.splice(unique.columnNames.indexOf(changedColumnSet.oldColumn.name), 1);
                    unique.columnNames.push(changedColumnSet.newColumn.name);
                    // rename Unique only if it has default constraint name
                    if (unique.name === uniqueName) {
                      unique.name = _this5.connection.namingStrategy.uniqueConstraintName(changedTable, unique.columnNames);
                    }
                  });
                  changedTable.findColumnForeignKeys(changedColumnSet.oldColumn).forEach(function (foreignKey) {
                    var foreignKeyName = _this5.connection.namingStrategy.foreignKeyName(table, foreignKey.columnNames, _this5.getTablePath(foreignKey), foreignKey.referencedColumnNames);
                    foreignKey.columnNames.splice(foreignKey.columnNames.indexOf(changedColumnSet.oldColumn.name), 1);
                    foreignKey.columnNames.push(changedColumnSet.newColumn.name);
                    // rename FK only if it has default constraint name
                    if (foreignKey.name === foreignKeyName) {
                      foreignKey.name = _this5.connection.namingStrategy.foreignKeyName(changedTable, foreignKey.columnNames, _this5.getTablePath(foreignKey), foreignKey.referencedColumnNames);
                    }
                  });
                  changedTable.findColumnIndices(changedColumnSet.oldColumn).forEach(function (index) {
                    var indexName = _this5.connection.namingStrategy.indexName(table, index.columnNames, index.where);
                    index.columnNames.splice(index.columnNames.indexOf(changedColumnSet.oldColumn.name), 1);
                    index.columnNames.push(changedColumnSet.newColumn.name);
                    // rename Index only if it has default constraint name
                    if (index.name === indexName) {
                      index.name = _this5.connection.namingStrategy.indexName(changedTable, index.columnNames, index.where);
                    }
                  });
                }
                var originalColumn = changedTable.columns.find(function (column) {
                  return column.name === changedColumnSet.oldColumn.name;
                });
                if (originalColumn) changedTable.columns[changedTable.columns.indexOf(originalColumn)] = changedColumnSet.newColumn;
              });
              _context25.next = 12;
              return this.recreateTable(changedTable, table);
            case 12:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function changeColumns(_x33, _x34) {
        return _changeColumns.apply(this, arguments);
      }
      return changeColumns;
    }()
    /**
     * Drops column in the table.
     */
  }, {
    key: "dropColumn",
    value: function () {
      var _dropColumn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(tableOrName, columnOrName) {
        var table, column;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context26.next = 4;
                break;
              }
              _context26.t0 = tableOrName;
              _context26.next = 7;
              break;
            case 4:
              _context26.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context26.t0 = _context26.sent;
            case 7:
              table = _context26.t0;
              column = InstanceChecker.isTableColumn(columnOrName) ? columnOrName : table.findColumnByName(columnOrName);
              if (column) {
                _context26.next = 11;
                break;
              }
              throw new TypeORMError("Column \"".concat(columnOrName, "\" was not found in table \"").concat(table.name, "\""));
            case 11:
              _context26.next = 13;
              return this.dropColumns(table, [column]);
            case 13:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function dropColumn(_x35, _x36) {
        return _dropColumn.apply(this, arguments);
      }
      return dropColumn;
    }()
    /**
     * Drops the columns in the table.
     */
  }, {
    key: "dropColumns",
    value: function () {
      var _dropColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(tableOrName, columns) {
        var table, changedTable;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context27.next = 4;
                break;
              }
              _context27.t0 = tableOrName;
              _context27.next = 7;
              break;
            case 4:
              _context27.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context27.t0 = _context27.sent;
            case 7:
              table = _context27.t0;
              // clone original table and remove column and its constraints from cloned table
              changedTable = table.clone();
              columns.forEach(function (column) {
                var columnInstance = InstanceChecker.isTableColumn(column) ? column : table.findColumnByName(column);
                if (!columnInstance) throw new Error("Column \"".concat(column, "\" was not found in table \"").concat(table.name, "\""));
                changedTable.removeColumn(columnInstance);
                changedTable.findColumnUniques(columnInstance).forEach(function (unique) {
                  return changedTable.removeUniqueConstraint(unique);
                });
                changedTable.findColumnIndices(columnInstance).forEach(function (index) {
                  return changedTable.removeIndex(index);
                });
                changedTable.findColumnForeignKeys(columnInstance).forEach(function (fk) {
                  return changedTable.removeForeignKey(fk);
                });
              });
              _context27.next = 12;
              return this.recreateTable(changedTable, table);
            case 12:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function dropColumns(_x37, _x38) {
        return _dropColumns.apply(this, arguments);
      }
      return dropColumns;
    }()
    /**
     * Creates a new primary key.
     */
  }, {
    key: "createPrimaryKey",
    value: function () {
      var _createPrimaryKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(tableOrName, columnNames) {
        var table, changedTable;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context28.next = 4;
                break;
              }
              _context28.t0 = tableOrName;
              _context28.next = 7;
              break;
            case 4:
              _context28.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context28.t0 = _context28.sent;
            case 7:
              table = _context28.t0;
              // clone original table and mark columns as primary
              changedTable = table.clone();
              changedTable.columns.forEach(function (column) {
                if (columnNames.find(function (columnName) {
                  return columnName === column.name;
                })) column.isPrimary = true;
              });
              _context28.next = 12;
              return this.recreateTable(changedTable, table);
            case 12:
              // mark columns as primary in original table
              table.columns.forEach(function (column) {
                if (columnNames.find(function (columnName) {
                  return columnName === column.name;
                })) column.isPrimary = true;
              });
            case 13:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function createPrimaryKey(_x39, _x40) {
        return _createPrimaryKey.apply(this, arguments);
      }
      return createPrimaryKey;
    }()
    /**
     * Updates composite primary keys.
     */
  }, {
    key: "updatePrimaryKeys",
    value: function () {
      var _updatePrimaryKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(tableOrName, columns) {
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return Promise.resolve();
            case 2:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }));
      function updatePrimaryKeys(_x41, _x42) {
        return _updatePrimaryKeys.apply(this, arguments);
      }
      return updatePrimaryKeys;
    }()
    /**
     * Drops a primary key.
     */
  }, {
    key: "dropPrimaryKey",
    value: function () {
      var _dropPrimaryKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(tableOrName) {
        var table, changedTable;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context30.next = 4;
                break;
              }
              _context30.t0 = tableOrName;
              _context30.next = 7;
              break;
            case 4:
              _context30.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context30.t0 = _context30.sent;
            case 7:
              table = _context30.t0;
              // clone original table and mark primary columns as non-primary
              changedTable = table.clone();
              changedTable.primaryColumns.forEach(function (column) {
                column.isPrimary = false;
              });
              _context30.next = 12;
              return this.recreateTable(changedTable, table);
            case 12:
              // mark primary columns as non-primary in original table
              table.primaryColumns.forEach(function (column) {
                column.isPrimary = false;
              });
            case 13:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function dropPrimaryKey(_x43) {
        return _dropPrimaryKey.apply(this, arguments);
      }
      return dropPrimaryKey;
    }()
    /**
     * Creates a new unique constraint.
     */
  }, {
    key: "createUniqueConstraint",
    value: function () {
      var _createUniqueConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(tableOrName, uniqueConstraint) {
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return this.createUniqueConstraints(tableOrName, [uniqueConstraint]);
            case 2:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function createUniqueConstraint(_x44, _x45) {
        return _createUniqueConstraint.apply(this, arguments);
      }
      return createUniqueConstraint;
    }()
    /**
     * Creates a new unique constraints.
     */
  }, {
    key: "createUniqueConstraints",
    value: function () {
      var _createUniqueConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(tableOrName, uniqueConstraints) {
        var table, changedTable;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context32.next = 4;
                break;
              }
              _context32.t0 = tableOrName;
              _context32.next = 7;
              break;
            case 4:
              _context32.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context32.t0 = _context32.sent;
            case 7:
              table = _context32.t0;
              // clone original table and add unique constraints in to cloned table
              changedTable = table.clone();
              uniqueConstraints.forEach(function (uniqueConstraint) {
                return changedTable.addUniqueConstraint(uniqueConstraint);
              });
              _context32.next = 12;
              return this.recreateTable(changedTable, table);
            case 12:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function createUniqueConstraints(_x46, _x47) {
        return _createUniqueConstraints.apply(this, arguments);
      }
      return createUniqueConstraints;
    }()
    /**
     * Drops an unique constraint.
     */
  }, {
    key: "dropUniqueConstraint",
    value: function () {
      var _dropUniqueConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(tableOrName, uniqueOrName) {
        var table, uniqueConstraint;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context33.next = 4;
                break;
              }
              _context33.t0 = tableOrName;
              _context33.next = 7;
              break;
            case 4:
              _context33.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context33.t0 = _context33.sent;
            case 7:
              table = _context33.t0;
              uniqueConstraint = InstanceChecker.isTableUnique(uniqueOrName) ? uniqueOrName : table.uniques.find(function (u) {
                return u.name === uniqueOrName;
              });
              if (uniqueConstraint) {
                _context33.next = 11;
                break;
              }
              throw new TypeORMError("Supplied unique constraint was not found in table ".concat(table.name));
            case 11:
              _context33.next = 13;
              return this.dropUniqueConstraints(table, [uniqueConstraint]);
            case 13:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function dropUniqueConstraint(_x48, _x49) {
        return _dropUniqueConstraint.apply(this, arguments);
      }
      return dropUniqueConstraint;
    }()
    /**
     * Creates an unique constraints.
     */
  }, {
    key: "dropUniqueConstraints",
    value: function () {
      var _dropUniqueConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(tableOrName, uniqueConstraints) {
        var table, changedTable;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context34.next = 4;
                break;
              }
              _context34.t0 = tableOrName;
              _context34.next = 7;
              break;
            case 4:
              _context34.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context34.t0 = _context34.sent;
            case 7:
              table = _context34.t0;
              // clone original table and remove unique constraints from cloned table
              changedTable = table.clone();
              uniqueConstraints.forEach(function (uniqueConstraint) {
                return changedTable.removeUniqueConstraint(uniqueConstraint);
              });
              _context34.next = 12;
              return this.recreateTable(changedTable, table);
            case 12:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function dropUniqueConstraints(_x50, _x51) {
        return _dropUniqueConstraints.apply(this, arguments);
      }
      return dropUniqueConstraints;
    }()
    /**
     * Creates new check constraint.
     */
  }, {
    key: "createCheckConstraint",
    value: function () {
      var _createCheckConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(tableOrName, checkConstraint) {
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return this.createCheckConstraints(tableOrName, [checkConstraint]);
            case 2:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
      function createCheckConstraint(_x52, _x53) {
        return _createCheckConstraint.apply(this, arguments);
      }
      return createCheckConstraint;
    }()
    /**
     * Creates new check constraints.
     */
  }, {
    key: "createCheckConstraints",
    value: function () {
      var _createCheckConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(tableOrName, checkConstraints) {
        var table, changedTable;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context36.next = 4;
                break;
              }
              _context36.t0 = tableOrName;
              _context36.next = 7;
              break;
            case 4:
              _context36.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context36.t0 = _context36.sent;
            case 7:
              table = _context36.t0;
              // clone original table and add check constraints in to cloned table
              changedTable = table.clone();
              checkConstraints.forEach(function (checkConstraint) {
                return changedTable.addCheckConstraint(checkConstraint);
              });
              _context36.next = 12;
              return this.recreateTable(changedTable, table);
            case 12:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
      function createCheckConstraints(_x54, _x55) {
        return _createCheckConstraints.apply(this, arguments);
      }
      return createCheckConstraints;
    }()
    /**
     * Drops check constraint.
     */
  }, {
    key: "dropCheckConstraint",
    value: function () {
      var _dropCheckConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37(tableOrName, checkOrName) {
        var table, checkConstraint;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context37.next = 4;
                break;
              }
              _context37.t0 = tableOrName;
              _context37.next = 7;
              break;
            case 4:
              _context37.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context37.t0 = _context37.sent;
            case 7:
              table = _context37.t0;
              checkConstraint = InstanceChecker.isTableCheck(checkOrName) ? checkOrName : table.checks.find(function (c) {
                return c.name === checkOrName;
              });
              if (checkConstraint) {
                _context37.next = 11;
                break;
              }
              throw new TypeORMError("Supplied check constraint was not found in table ".concat(table.name));
            case 11:
              _context37.next = 13;
              return this.dropCheckConstraints(table, [checkConstraint]);
            case 13:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this);
      }));
      function dropCheckConstraint(_x56, _x57) {
        return _dropCheckConstraint.apply(this, arguments);
      }
      return dropCheckConstraint;
    }()
    /**
     * Drops check constraints.
     */
  }, {
    key: "dropCheckConstraints",
    value: function () {
      var _dropCheckConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38(tableOrName, checkConstraints) {
        var table, changedTable;
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context38.next = 4;
                break;
              }
              _context38.t0 = tableOrName;
              _context38.next = 7;
              break;
            case 4:
              _context38.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context38.t0 = _context38.sent;
            case 7:
              table = _context38.t0;
              // clone original table and remove check constraints from cloned table
              changedTable = table.clone();
              checkConstraints.forEach(function (checkConstraint) {
                return changedTable.removeCheckConstraint(checkConstraint);
              });
              _context38.next = 12;
              return this.recreateTable(changedTable, table);
            case 12:
            case "end":
              return _context38.stop();
          }
        }, _callee38, this);
      }));
      function dropCheckConstraints(_x58, _x59) {
        return _dropCheckConstraints.apply(this, arguments);
      }
      return dropCheckConstraints;
    }()
    /**
     * Creates a new exclusion constraint.
     */
  }, {
    key: "createExclusionConstraint",
    value: function () {
      var _createExclusionConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39(tableOrName, exclusionConstraint) {
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              throw new TypeORMError("Sqlite does not support exclusion constraints.");
            case 1:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      }));
      function createExclusionConstraint(_x60, _x61) {
        return _createExclusionConstraint.apply(this, arguments);
      }
      return createExclusionConstraint;
    }()
    /**
     * Creates a new exclusion constraints.
     */
  }, {
    key: "createExclusionConstraints",
    value: function () {
      var _createExclusionConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40(tableOrName, exclusionConstraints) {
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              throw new TypeORMError("Sqlite does not support exclusion constraints.");
            case 1:
            case "end":
              return _context40.stop();
          }
        }, _callee40);
      }));
      function createExclusionConstraints(_x62, _x63) {
        return _createExclusionConstraints.apply(this, arguments);
      }
      return createExclusionConstraints;
    }()
    /**
     * Drops exclusion constraint.
     */
  }, {
    key: "dropExclusionConstraint",
    value: function () {
      var _dropExclusionConstraint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41(tableOrName, exclusionOrName) {
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              throw new TypeORMError("Sqlite does not support exclusion constraints.");
            case 1:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      }));
      function dropExclusionConstraint(_x64, _x65) {
        return _dropExclusionConstraint.apply(this, arguments);
      }
      return dropExclusionConstraint;
    }()
    /**
     * Drops exclusion constraints.
     */
  }, {
    key: "dropExclusionConstraints",
    value: function () {
      var _dropExclusionConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42(tableOrName, exclusionConstraints) {
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              throw new TypeORMError("Sqlite does not support exclusion constraints.");
            case 1:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      }));
      function dropExclusionConstraints(_x66, _x67) {
        return _dropExclusionConstraints.apply(this, arguments);
      }
      return dropExclusionConstraints;
    }()
    /**
     * Creates a new foreign key.
     */
  }, {
    key: "createForeignKey",
    value: function () {
      var _createForeignKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43(tableOrName, foreignKey) {
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return this.createForeignKeys(tableOrName, [foreignKey]);
            case 2:
            case "end":
              return _context43.stop();
          }
        }, _callee43, this);
      }));
      function createForeignKey(_x68, _x69) {
        return _createForeignKey.apply(this, arguments);
      }
      return createForeignKey;
    }()
    /**
     * Creates a new foreign keys.
     */
  }, {
    key: "createForeignKeys",
    value: function () {
      var _createForeignKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44(tableOrName, foreignKeys) {
        var table, changedTable;
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context44.next = 4;
                break;
              }
              _context44.t0 = tableOrName;
              _context44.next = 7;
              break;
            case 4:
              _context44.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context44.t0 = _context44.sent;
            case 7:
              table = _context44.t0;
              // clone original table and add foreign keys in to cloned table
              changedTable = table.clone();
              foreignKeys.forEach(function (foreignKey) {
                return changedTable.addForeignKey(foreignKey);
              });
              _context44.next = 12;
              return this.recreateTable(changedTable, table);
            case 12:
            case "end":
              return _context44.stop();
          }
        }, _callee44, this);
      }));
      function createForeignKeys(_x70, _x71) {
        return _createForeignKeys.apply(this, arguments);
      }
      return createForeignKeys;
    }()
    /**
     * Drops a foreign key from the table.
     */
  }, {
    key: "dropForeignKey",
    value: function () {
      var _dropForeignKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45(tableOrName, foreignKeyOrName) {
        var table, foreignKey;
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context45.next = 4;
                break;
              }
              _context45.t0 = tableOrName;
              _context45.next = 7;
              break;
            case 4:
              _context45.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context45.t0 = _context45.sent;
            case 7:
              table = _context45.t0;
              foreignKey = InstanceChecker.isTableForeignKey(foreignKeyOrName) ? foreignKeyOrName : table.foreignKeys.find(function (fk) {
                return fk.name === foreignKeyOrName;
              });
              if (foreignKey) {
                _context45.next = 11;
                break;
              }
              throw new TypeORMError("Supplied foreign key was not found in table ".concat(table.name));
            case 11:
              _context45.next = 13;
              return this.dropForeignKeys(tableOrName, [foreignKey]);
            case 13:
            case "end":
              return _context45.stop();
          }
        }, _callee45, this);
      }));
      function dropForeignKey(_x72, _x73) {
        return _dropForeignKey.apply(this, arguments);
      }
      return dropForeignKey;
    }()
    /**
     * Drops a foreign keys from the table.
     */
  }, {
    key: "dropForeignKeys",
    value: function () {
      var _dropForeignKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46(tableOrName, foreignKeys) {
        var table, changedTable;
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context46.next = 4;
                break;
              }
              _context46.t0 = tableOrName;
              _context46.next = 7;
              break;
            case 4:
              _context46.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context46.t0 = _context46.sent;
            case 7:
              table = _context46.t0;
              // clone original table and remove foreign keys from cloned table
              changedTable = table.clone();
              foreignKeys.forEach(function (foreignKey) {
                return changedTable.removeForeignKey(foreignKey);
              });
              _context46.next = 12;
              return this.recreateTable(changedTable, table);
            case 12:
            case "end":
              return _context46.stop();
          }
        }, _callee46, this);
      }));
      function dropForeignKeys(_x74, _x75) {
        return _dropForeignKeys.apply(this, arguments);
      }
      return dropForeignKeys;
    }()
    /**
     * Creates a new index.
     */
  }, {
    key: "createIndex",
    value: function () {
      var _createIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47(tableOrName, index) {
        var table, up, down;
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context47.next = 4;
                break;
              }
              _context47.t0 = tableOrName;
              _context47.next = 7;
              break;
            case 4:
              _context47.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context47.t0 = _context47.sent;
            case 7:
              table = _context47.t0;
              // new index may be passed without name. In this case we generate index name manually.
              if (!index.name) index.name = this.generateIndexName(table, index);
              up = this.createIndexSql(table, index);
              down = this.dropIndexSql(index);
              _context47.next = 13;
              return this.executeQueries(up, down);
            case 13:
              table.addIndex(index);
            case 14:
            case "end":
              return _context47.stop();
          }
        }, _callee47, this);
      }));
      function createIndex(_x76, _x77) {
        return _createIndex.apply(this, arguments);
      }
      return createIndex;
    }()
    /**
     * Creates a new indices
     */
  }, {
    key: "createIndices",
    value: function () {
      var _createIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48(tableOrName, indices) {
        var _this6 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              promises = indices.map(function (index) {
                return _this6.createIndex(tableOrName, index);
              });
              _context48.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context48.stop();
          }
        }, _callee48);
      }));
      function createIndices(_x78, _x79) {
        return _createIndices.apply(this, arguments);
      }
      return createIndices;
    }()
    /**
     * Drops an index from the table.
     */
  }, {
    key: "dropIndex",
    value: function () {
      var _dropIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49(tableOrName, indexOrName) {
        var table, index, up, down;
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              if (!InstanceChecker.isTable(tableOrName)) {
                _context49.next = 4;
                break;
              }
              _context49.t0 = tableOrName;
              _context49.next = 7;
              break;
            case 4:
              _context49.next = 6;
              return this.getCachedTable(tableOrName);
            case 6:
              _context49.t0 = _context49.sent;
            case 7:
              table = _context49.t0;
              index = InstanceChecker.isTableIndex(indexOrName) ? indexOrName : table.indices.find(function (i) {
                return i.name === indexOrName;
              });
              if (index) {
                _context49.next = 11;
                break;
              }
              throw new TypeORMError("Supplied index ".concat(indexOrName, " was not found in table ").concat(table.name));
            case 11:
              // old index may be passed without name. In this case we generate index name manually.
              if (!index.name) index.name = this.generateIndexName(table, index);
              up = this.dropIndexSql(index);
              down = this.createIndexSql(table, index);
              _context49.next = 16;
              return this.executeQueries(up, down);
            case 16:
              table.removeIndex(index);
            case 17:
            case "end":
              return _context49.stop();
          }
        }, _callee49, this);
      }));
      function dropIndex(_x80, _x81) {
        return _dropIndex.apply(this, arguments);
      }
      return dropIndex;
    }()
    /**
     * Drops an indices from the table.
     */
  }, {
    key: "dropIndices",
    value: function () {
      var _dropIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50(tableOrName, indices) {
        var _this7 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              promises = indices.map(function (index) {
                return _this7.dropIndex(tableOrName, index);
              });
              _context50.next = 3;
              return Promise.all(promises);
            case 3:
            case "end":
              return _context50.stop();
          }
        }, _callee50);
      }));
      function dropIndices(_x82, _x83) {
        return _dropIndices.apply(this, arguments);
      }
      return dropIndices;
    }()
    /**
     * Clears all table contents.
     * Note: this operation uses SQL's TRUNCATE query which cannot be reverted in transactions.
     */
  }, {
    key: "clearTable",
    value: function () {
      var _clearTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51(tableName) {
        return _regeneratorRuntime().wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              _context51.next = 2;
              return this.query("DELETE FROM ".concat(this.escapePath(tableName)));
            case 2:
            case "end":
              return _context51.stop();
          }
        }, _callee51, this);
      }));
      function clearTable(_x84) {
        return _clearTable.apply(this, arguments);
      }
      return clearTable;
    }()
    /**
     * Removes all tables from the currently connected database.
     */
  }, {
    key: "clearDatabase",
    value: function () {
      var _clearDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52(database) {
        var _this8 = this;
        var dbPath, isAnotherTransactionActive, selectViewDropsQuery, dropViewQueries, selectTableDropsQuery, dropTableQueries;
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              dbPath = undefined;
              if (database && this.driver.getAttachedDatabaseHandleByRelativePath(database)) {
                dbPath = this.driver.getAttachedDatabaseHandleByRelativePath(database);
              }
              _context52.next = 4;
              return this.query("PRAGMA foreign_keys = OFF");
            case 4:
              isAnotherTransactionActive = this.isTransactionActive;
              if (isAnotherTransactionActive) {
                _context52.next = 8;
                break;
              }
              _context52.next = 8;
              return this.startTransaction();
            case 8:
              _context52.prev = 8;
              selectViewDropsQuery = dbPath ? "SELECT 'DROP VIEW \"".concat(dbPath, "\".\"' || name || '\";' as query FROM \"").concat(dbPath, "\".\"sqlite_master\" WHERE \"type\" = 'view'") : "SELECT 'DROP VIEW \"' || name || '\";' as query FROM \"sqlite_master\" WHERE \"type\" = 'view'";
              _context52.next = 12;
              return this.query(selectViewDropsQuery);
            case 12:
              dropViewQueries = _context52.sent;
              _context52.next = 15;
              return Promise.all(dropViewQueries.map(function (q) {
                return _this8.query(q["query"]);
              }));
            case 15:
              selectTableDropsQuery = dbPath ? "SELECT 'DROP TABLE \"".concat(dbPath, "\".\"' || name || '\";' as query FROM \"").concat(dbPath, "\".\"sqlite_master\" WHERE \"type\" = 'table' AND \"name\" != 'sqlite_sequence'") : "SELECT 'DROP TABLE \"' || name || '\";' as query FROM \"sqlite_master\" WHERE \"type\" = 'table' AND \"name\" != 'sqlite_sequence'";
              _context52.next = 18;
              return this.query(selectTableDropsQuery);
            case 18:
              dropTableQueries = _context52.sent;
              _context52.next = 21;
              return Promise.all(dropTableQueries.map(function (q) {
                return _this8.query(q["query"]);
              }));
            case 21:
              if (isAnotherTransactionActive) {
                _context52.next = 24;
                break;
              }
              _context52.next = 24;
              return this.commitTransaction();
            case 24:
              _context52.next = 37;
              break;
            case 26:
              _context52.prev = 26;
              _context52.t0 = _context52["catch"](8);
              _context52.prev = 28;
              if (isAnotherTransactionActive) {
                _context52.next = 32;
                break;
              }
              _context52.next = 32;
              return this.rollbackTransaction();
            case 32:
              _context52.next = 36;
              break;
            case 34:
              _context52.prev = 34;
              _context52.t1 = _context52["catch"](28);
            case 36:
              throw _context52.t0;
            case 37:
              _context52.prev = 37;
              _context52.next = 40;
              return this.query("PRAGMA foreign_keys = ON");
            case 40:
              return _context52.finish(37);
            case 41:
            case "end":
              return _context52.stop();
          }
        }, _callee52, this, [[8, 26, 37, 41], [28, 34]]);
      }));
      function clearDatabase(_x85) {
        return _clearDatabase.apply(this, arguments);
      }
      return clearDatabase;
    }() // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
  }, {
    key: "loadViews",
    value: function () {
      var _loadViews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53(viewNames) {
        var hasTable, viewNamesString, query, dbViews;
        return _regeneratorRuntime().wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              _context53.next = 2;
              return this.hasTable(this.getTypeormMetadataTableName());
            case 2:
              hasTable = _context53.sent;
              if (hasTable) {
                _context53.next = 5;
                break;
              }
              return _context53.abrupt("return", []);
            case 5:
              if (!viewNames) {
                viewNames = [];
              }
              viewNamesString = viewNames.map(function (name) {
                return "'" + name + "'";
              }).join(", ");
              query = "SELECT \"t\".* FROM \"".concat(this.getTypeormMetadataTableName(), "\" \"t\" INNER JOIN \"sqlite_master\" s ON \"s\".\"name\" = \"t\".\"name\" AND \"s\".\"type\" = 'view' WHERE \"t\".\"type\" = '").concat(MetadataTableType.VIEW, "'");
              if (viewNamesString.length > 0) query += " AND \"t\".\"name\" IN (".concat(viewNamesString, ")");
              _context53.next = 11;
              return this.query(query);
            case 11:
              dbViews = _context53.sent;
              return _context53.abrupt("return", dbViews.map(function (dbView) {
                var view = new View();
                view.name = dbView["name"];
                view.expression = dbView["value"];
                return view;
              }));
            case 13:
            case "end":
              return _context53.stop();
          }
        }, _callee53, this);
      }));
      function loadViews(_x86) {
        return _loadViews.apply(this, arguments);
      }
      return loadViews;
    }()
  }, {
    key: "loadTableRecords",
    value: function () {
      var _loadTableRecords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee54(tablePath, tableOrIndex) {
        var database, _this$splitTablePath, _this$splitTablePath2, schema, tableName, res;
        return _regeneratorRuntime().wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              database = undefined;
              _this$splitTablePath = this.splitTablePath(tablePath), _this$splitTablePath2 = _slicedToArray(_this$splitTablePath, 2), schema = _this$splitTablePath2[0], tableName = _this$splitTablePath2[1];
              if (schema && this.driver.getAttachedDatabasePathRelativeByHandle(schema)) {
                database = this.driver.getAttachedDatabasePathRelativeByHandle(schema);
              }
              _context54.next = 5;
              return this.query("SELECT ".concat(database ? "'".concat(database, "'") : null, " as database, ").concat(schema ? "'".concat(schema, "'") : null, " as schema, * FROM ").concat(schema ? "\"".concat(schema, "\".") : "").concat(this.escapePath("sqlite_master"), " WHERE \"type\" = '").concat(tableOrIndex, "' AND \"").concat(tableOrIndex === "table" ? "name" : "tbl_name", "\" IN ('").concat(tableName, "')"));
            case 5:
              res = _context54.sent;
              return _context54.abrupt("return", res);
            case 7:
            case "end":
              return _context54.stop();
          }
        }, _callee54, this);
      }));
      function loadTableRecords(_x87, _x88) {
        return _loadTableRecords.apply(this, arguments);
      }
      return loadTableRecords;
    }()
  }, {
    key: "loadPragmaRecords",
    value: function () {
      var _loadPragmaRecords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee55(tablePath, pragma) {
        var _this$splitTablePath3, _this$splitTablePath4, tableName, res;
        return _regeneratorRuntime().wrap(function _callee55$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              _this$splitTablePath3 = this.splitTablePath(tablePath), _this$splitTablePath4 = _slicedToArray(_this$splitTablePath3, 2), tableName = _this$splitTablePath4[1];
              _context55.next = 3;
              return this.query("PRAGMA ".concat(pragma, "(\"").concat(tableName, "\")"));
            case 3:
              res = _context55.sent;
              return _context55.abrupt("return", res);
            case 5:
            case "end":
              return _context55.stop();
          }
        }, _callee55, this);
      }));
      function loadPragmaRecords(_x89, _x90) {
        return _loadPragmaRecords.apply(this, arguments);
      }
      return loadPragmaRecords;
    }()
    /**
     * Loads all tables (with given names) from the database and creates a Table from them.
     */
  }, {
    key: "loadTables",
    value: function () {
      var _loadTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee60(tableNames) {
        var _this9 = this;
        var dbTables, dbIndicesDef, _dbTables, tablesSql, tableNamesString;
        return _regeneratorRuntime().wrap(function _callee60$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              if (!(tableNames && tableNames.length === 0)) {
                _context60.next = 2;
                break;
              }
              return _context60.abrupt("return", []);
            case 2:
              dbTables = [];
              if (tableNames) {
                _context60.next = 19;
                break;
              }
              tablesSql = "SELECT * FROM \"sqlite_master\" WHERE \"type\" = 'table'";
              _context60.t0 = (_dbTables = dbTables).push;
              _context60.t1 = _dbTables;
              _context60.t2 = _toConsumableArray;
              _context60.next = 10;
              return this.query(tablesSql);
            case 10:
              _context60.t3 = _context60.sent;
              _context60.t4 = (0, _context60.t2)(_context60.t3);
              _context60.t0.apply.call(_context60.t0, _context60.t1, _context60.t4);
              tableNamesString = dbTables.map(function (_ref) {
                var name = _ref.name;
                return "'".concat(name, "'");
              }).join(", ");
              _context60.next = 16;
              return this.query("SELECT * FROM \"sqlite_master\" WHERE \"type\" = 'index' AND \"tbl_name\" IN (".concat(tableNamesString, ")"));
            case 16:
              dbIndicesDef = _context60.sent;
              _context60.next = 25;
              break;
            case 19:
              _context60.next = 21;
              return Promise.all(tableNames.map(function (tableName) {
                return _this9.loadTableRecords(tableName, "table");
              }));
            case 21:
              dbTables = _context60.sent.reduce(function (acc, res) {
                return [].concat(_toConsumableArray(acc), _toConsumableArray(res));
              }, []).filter(Boolean);
              _context60.next = 24;
              return Promise.all((tableNames !== null && tableNames !== void 0 ? tableNames : []).map(function (tableName) {
                return _this9.loadTableRecords(tableName, "index");
              }));
            case 24:
              dbIndicesDef = _context60.sent.reduce(function (acc, res) {
                return [].concat(_toConsumableArray(acc), _toConsumableArray(res));
              }, []).filter(Boolean);
            case 25:
              if (!(dbTables.length === 0)) {
                _context60.next = 27;
                break;
              }
              return _context60.abrupt("return", []);
            case 27:
              return _context60.abrupt("return", Promise.all(dbTables.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee59(dbTable) {
                  var tablePath, sql, withoutRowid, table, _yield$Promise$all, _yield$Promise$all2, dbColumns, dbIndices, dbForeignKeys, autoIncrementColumnName, tableSql, autoIncrementIndex, comma, bracket, fkResult, fkMappings, fkRegex, tableForeignKeyConstraints, uniqueRegexResult, uniqueMappings, uniqueRegex, tableUniquePromises, result, regexp, indicesPromises, indices;
                  return _regeneratorRuntime().wrap(function _callee59$(_context59) {
                    while (1) switch (_context59.prev = _context59.next) {
                      case 0:
                        tablePath = dbTable["database"] && _this9.driver.getAttachedDatabaseHandleByRelativePath(dbTable["database"]) ? "".concat(_this9.driver.getAttachedDatabaseHandleByRelativePath(dbTable["database"]), ".").concat(dbTable["name"]) : dbTable["name"];
                        sql = dbTable["sql"];
                        withoutRowid = sql.includes("WITHOUT ROWID");
                        table = new Table({
                          name: tablePath,
                          withoutRowid: withoutRowid
                        }); // load columns and indices
                        _context59.next = 6;
                        return Promise.all([_this9.loadPragmaRecords(tablePath, "table_xinfo"), _this9.loadPragmaRecords(tablePath, "index_list"), _this9.loadPragmaRecords(tablePath, "foreign_key_list")]);
                      case 6:
                        _yield$Promise$all = _context59.sent;
                        _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
                        dbColumns = _yield$Promise$all2[0];
                        dbIndices = _yield$Promise$all2[1];
                        dbForeignKeys = _yield$Promise$all2[2];
                        // find column name with auto increment
                        autoIncrementColumnName = undefined;
                        tableSql = dbTable["sql"];
                        autoIncrementIndex = tableSql.toUpperCase().indexOf("AUTOINCREMENT");
                        if (autoIncrementIndex !== -1) {
                          autoIncrementColumnName = tableSql.substr(0, autoIncrementIndex);
                          comma = autoIncrementColumnName.lastIndexOf(",");
                          bracket = autoIncrementColumnName.lastIndexOf("(");
                          if (comma !== -1) {
                            autoIncrementColumnName = autoIncrementColumnName.substr(comma);
                            autoIncrementColumnName = autoIncrementColumnName.substr(0, autoIncrementColumnName.lastIndexOf('"'));
                            autoIncrementColumnName = autoIncrementColumnName.substr(autoIncrementColumnName.indexOf('"') + 1);
                          } else if (bracket !== -1) {
                            autoIncrementColumnName = autoIncrementColumnName.substr(bracket);
                            autoIncrementColumnName = autoIncrementColumnName.substr(0, autoIncrementColumnName.lastIndexOf('"'));
                            autoIncrementColumnName = autoIncrementColumnName.substr(autoIncrementColumnName.indexOf('"') + 1);
                          }
                        }
                        // create columns from the loaded columns
                        _context59.next = 17;
                        return Promise.all(dbColumns.map( /*#__PURE__*/function () {
                          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee56(dbColumn) {
                            var tableColumn, asExpressionQuery, results, enumMatch, pos, fullType, dataType, len, re, matches;
                            return _regeneratorRuntime().wrap(function _callee56$(_context56) {
                              while (1) switch (_context56.prev = _context56.next) {
                                case 0:
                                  tableColumn = new TableColumn();
                                  tableColumn.name = dbColumn["name"];
                                  tableColumn.type = dbColumn["type"].toLowerCase();
                                  tableColumn.default = dbColumn["dflt_value"] !== null && dbColumn["dflt_value"] !== undefined ? dbColumn["dflt_value"] : undefined;
                                  tableColumn.isNullable = dbColumn["notnull"] === 0;
                                  // primary keys are numbered starting with 1, columns that aren't primary keys are marked with 0
                                  tableColumn.isPrimary = dbColumn["pk"] > 0;
                                  tableColumn.comment = ""; // SQLite does not support column comments
                                  tableColumn.isGenerated = autoIncrementColumnName === dbColumn["name"];
                                  if (tableColumn.isGenerated) {
                                    tableColumn.generationStrategy = "increment";
                                  }
                                  if (!(dbColumn["hidden"] === 2 || dbColumn["hidden"] === 3)) {
                                    _context56.next = 18;
                                    break;
                                  }
                                  tableColumn.generatedType = dbColumn["hidden"] === 2 ? "VIRTUAL" : "STORED";
                                  _context56.next = 13;
                                  return _this9.selectTypeormMetadataSql({
                                    table: table.name,
                                    type: MetadataTableType.GENERATED_COLUMN,
                                    name: tableColumn.name
                                  });
                                case 13:
                                  asExpressionQuery = _context56.sent;
                                  _context56.next = 16;
                                  return _this9.query(asExpressionQuery.query, asExpressionQuery.parameters);
                                case 16:
                                  results = _context56.sent;
                                  if (results[0] && results[0].value) {
                                    tableColumn.asExpression = results[0].value;
                                  } else {
                                    tableColumn.asExpression = "";
                                  }
                                case 18:
                                  if (tableColumn.type === "varchar") {
                                    // Check if this is an enum
                                    enumMatch = sql.match(new RegExp('"(' + tableColumn.name + ")\" varchar CHECK\\s*\\(\\s*\"\\1\"\\s+IN\\s*\\(('[^']+'(?:\\s*,\\s*'[^']+')+)\\s*\\)\\s*\\)"));
                                    if (enumMatch) {
                                      // This is an enum
                                      tableColumn.enum = enumMatch[2].substr(1, enumMatch[2].length - 2).split("','");
                                    }
                                  }
                                  // parse datatype and attempt to retrieve length, precision and scale
                                  pos = tableColumn.type.indexOf("(");
                                  if (pos !== -1) {
                                    fullType = tableColumn.type;
                                    dataType = fullType.substr(0, pos);
                                    if (!!_this9.driver.withLengthColumnTypes.find(function (col) {
                                      return col === dataType;
                                    })) {
                                      len = parseInt(fullType.substring(pos + 1, fullType.length - 1));
                                      if (len) {
                                        tableColumn.length = len.toString();
                                        tableColumn.type = dataType; // remove the length part from the datatype
                                      }
                                    }

                                    if (!!_this9.driver.withPrecisionColumnTypes.find(function (col) {
                                      return col === dataType;
                                    })) {
                                      re = new RegExp("^".concat(dataType, "\\((\\d+),?\\s?(\\d+)?\\)"));
                                      matches = fullType.match(re);
                                      if (matches && matches[1]) {
                                        tableColumn.precision = +matches[1];
                                      }
                                      if (!!_this9.driver.withScaleColumnTypes.find(function (col) {
                                        return col === dataType;
                                      })) {
                                        if (matches && matches[2]) {
                                          tableColumn.scale = +matches[2];
                                        }
                                      }
                                      tableColumn.type = dataType; // remove the precision/scale part from the datatype
                                    }
                                  }
                                  return _context56.abrupt("return", tableColumn);
                                case 22:
                                case "end":
                                  return _context56.stop();
                              }
                            }, _callee56);
                          }));
                          return function (_x93) {
                            return _ref3.apply(this, arguments);
                          };
                        }()));
                      case 17:
                        table.columns = _context59.sent;
                        fkMappings = [];
                        fkRegex = /CONSTRAINT "([^"]*)" FOREIGN KEY ?\((.*?)\) REFERENCES "([^"]*)"/g;
                        while ((fkResult = fkRegex.exec(sql)) !== null) {
                          fkMappings.push({
                            name: fkResult[1],
                            columns: fkResult[2].substr(1, fkResult[2].length - 2).split("\", \""),
                            referencedTableName: fkResult[3]
                          });
                        }
                        // build foreign keys
                        tableForeignKeyConstraints = OrmUtils.uniq(dbForeignKeys, function (dbForeignKey) {
                          return dbForeignKey["id"];
                        });
                        table.foreignKeys = tableForeignKeyConstraints.map(function (foreignKey) {
                          var ownForeignKeys = dbForeignKeys.filter(function (dbForeignKey) {
                            return dbForeignKey["id"] === foreignKey["id"] && dbForeignKey["table"] === foreignKey["table"];
                          });
                          var columnNames = ownForeignKeys.map(function (dbForeignKey) {
                            return dbForeignKey["from"];
                          });
                          var referencedColumnNames = ownForeignKeys.map(function (dbForeignKey) {
                            return dbForeignKey["to"];
                          });
                          // find related foreign key mapping
                          var fkMapping = fkMappings.find(function (it) {
                            return it.referencedTableName === foreignKey["table"] && it.columns.every(function (column) {
                              return columnNames.indexOf(column) !== -1;
                            });
                          });
                          return new TableForeignKey({
                            name: fkMapping.name,
                            columnNames: columnNames,
                            referencedTableName: foreignKey["table"],
                            referencedColumnNames: referencedColumnNames,
                            onDelete: foreignKey["on_delete"],
                            onUpdate: foreignKey["on_update"]
                          });
                        });
                        // find unique constraints from CREATE TABLE sql
                        uniqueMappings = [];
                        uniqueRegex = /CONSTRAINT "([^"]*)" UNIQUE ?\((.*?)\)/g;
                        while ((uniqueRegexResult = uniqueRegex.exec(sql)) !== null) {
                          uniqueMappings.push({
                            name: uniqueRegexResult[1],
                            columns: uniqueRegexResult[2].substr(1, uniqueRegexResult[2].length - 2).split("\", \"")
                          });
                        }
                        // build unique constraints
                        tableUniquePromises = dbIndices.filter(function (dbIndex) {
                          return dbIndex["origin"] === "u";
                        }).map(function (dbIndex) {
                          return dbIndex["name"];
                        }).filter(function (value, index, self) {
                          return self.indexOf(value) === index;
                        }).map( /*#__PURE__*/function () {
                          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee57(dbIndexName) {
                            var dbIndex, indexInfos, indexColumns, column, foundMapping;
                            return _regeneratorRuntime().wrap(function _callee57$(_context57) {
                              while (1) switch (_context57.prev = _context57.next) {
                                case 0:
                                  dbIndex = dbIndices.find(function (dbIndex) {
                                    return dbIndex["name"] === dbIndexName;
                                  });
                                  _context57.next = 3;
                                  return _this9.query("PRAGMA index_info(\"".concat(dbIndex["name"], "\")"));
                                case 3:
                                  indexInfos = _context57.sent;
                                  indexColumns = indexInfos.sort(function (indexInfo1, indexInfo2) {
                                    return parseInt(indexInfo1["seqno"]) - parseInt(indexInfo2["seqno"]);
                                  }).map(function (indexInfo) {
                                    return indexInfo["name"];
                                  });
                                  if (indexColumns.length === 1) {
                                    column = table.columns.find(function (column) {
                                      return !!indexColumns.find(function (indexColumn) {
                                        return indexColumn === column.name;
                                      });
                                    });
                                    if (column) column.isUnique = true;
                                  }
                                  // find existent mapping by a column names
                                  foundMapping = uniqueMappings.find(function (mapping) {
                                    return mapping.columns.every(function (column) {
                                      return indexColumns.indexOf(column) !== -1;
                                    });
                                  });
                                  return _context57.abrupt("return", new TableUnique({
                                    name: foundMapping ? foundMapping.name : _this9.connection.namingStrategy.uniqueConstraintName(table, indexColumns),
                                    columnNames: indexColumns
                                  }));
                                case 8:
                                case "end":
                                  return _context57.stop();
                              }
                            }, _callee57);
                          }));
                          return function (_x94) {
                            return _ref4.apply(this, arguments);
                          };
                        }());
                        _context59.next = 29;
                        return Promise.all(tableUniquePromises);
                      case 29:
                        table.uniques = _context59.sent;
                        regexp = /CONSTRAINT "([^"]*)" CHECK ?(\(.*?\))([,]|[)]$)/g;
                        while ((result = regexp.exec(sql)) !== null) {
                          table.checks.push(new TableCheck({
                            name: result[1],
                            expression: result[2]
                          }));
                        }
                        // build indices
                        indicesPromises = dbIndices.filter(function (dbIndex) {
                          return dbIndex["origin"] === "c";
                        }).map(function (dbIndex) {
                          return dbIndex["name"];
                        }).filter(function (value, index, self) {
                          return self.indexOf(value) === index;
                        }) // unqiue
                        .map( /*#__PURE__*/function () {
                          var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee58(dbIndexName) {
                            var indexDef, condition, dbIndex, indexInfos, indexColumns, dbIndexPath, isUnique;
                            return _regeneratorRuntime().wrap(function _callee58$(_context58) {
                              while (1) switch (_context58.prev = _context58.next) {
                                case 0:
                                  indexDef = dbIndicesDef.find(function (dbIndexDef) {
                                    return dbIndexDef["name"] === dbIndexName;
                                  });
                                  condition = /WHERE (.*)/.exec(indexDef["sql"]);
                                  dbIndex = dbIndices.find(function (dbIndex) {
                                    return dbIndex["name"] === dbIndexName;
                                  });
                                  _context58.next = 5;
                                  return _this9.query("PRAGMA index_info(\"".concat(dbIndex["name"], "\")"));
                                case 5:
                                  indexInfos = _context58.sent;
                                  indexColumns = indexInfos.sort(function (indexInfo1, indexInfo2) {
                                    return parseInt(indexInfo1["seqno"]) - parseInt(indexInfo2["seqno"]);
                                  }).map(function (indexInfo) {
                                    return indexInfo["name"];
                                  });
                                  dbIndexPath = "".concat(dbTable["database"] ? "".concat(dbTable["database"], ".") : "").concat(dbIndex["name"]);
                                  isUnique = dbIndex["unique"] === "1" || dbIndex["unique"] === 1;
                                  return _context58.abrupt("return", new TableIndex({
                                    table: table,
                                    name: dbIndexPath,
                                    columnNames: indexColumns,
                                    isUnique: isUnique,
                                    where: condition ? condition[1] : undefined
                                  }));
                                case 10:
                                case "end":
                                  return _context58.stop();
                              }
                            }, _callee58);
                          }));
                          return function (_x95) {
                            return _ref5.apply(this, arguments);
                          };
                        }());
                        _context59.next = 35;
                        return Promise.all(indicesPromises);
                      case 35:
                        indices = _context59.sent;
                        table.indices = indices.filter(function (index) {
                          return !!index;
                        });
                        return _context59.abrupt("return", table);
                      case 38:
                      case "end":
                        return _context59.stop();
                    }
                  }, _callee59);
                }));
                return function (_x92) {
                  return _ref2.apply(this, arguments);
                };
              }())));
            case 28:
            case "end":
              return _context60.stop();
          }
        }, _callee60, this);
      }));
      function loadTables(_x91) {
        return _loadTables.apply(this, arguments);
      }
      return loadTables;
    }()
    /**
     * Builds create table sql.
     */
  }, {
    key: "createTableSql",
    value: function createTableSql(table, createForeignKeys, temporaryTable) {
      var _this10 = this;
      var primaryColumns = table.columns.filter(function (column) {
        return column.isPrimary;
      });
      var hasAutoIncrement = primaryColumns.find(function (column) {
        return column.isGenerated && column.generationStrategy === "increment";
      });
      var skipPrimary = primaryColumns.length > 1;
      if (skipPrimary && hasAutoIncrement) throw new TypeORMError("Sqlite does not support AUTOINCREMENT on composite primary key");
      var columnDefinitions = table.columns.map(function (column) {
        return _this10.buildCreateColumnSql(column, skipPrimary);
      }).join(", ");
      var _this$splitTablePath5 = this.splitTablePath(table.name),
        _this$splitTablePath6 = _slicedToArray(_this$splitTablePath5, 1),
        database = _this$splitTablePath6[0];
      var sql = "CREATE TABLE ".concat(this.escapePath(table.name), " (").concat(columnDefinitions);
      var _this$splitTablePath7 = this.splitTablePath(table.name),
        _this$splitTablePath8 = _slicedToArray(_this$splitTablePath7, 2),
        databaseNew = _this$splitTablePath8[0],
        tableName = _this$splitTablePath8[1];
      var newTableName = temporaryTable ? "".concat(databaseNew ? "".concat(databaseNew, ".") : "").concat(tableName.replace(/^temporary_/, "")) : table.name;
      // need for `addColumn()` method, because it recreates table.
      table.columns.filter(function (column) {
        return column.isUnique;
      }).forEach(function (column) {
        var isUniqueExist = table.uniques.some(function (unique) {
          return unique.columnNames.length === 1 && unique.columnNames[0] === column.name;
        });
        if (!isUniqueExist) table.uniques.push(new TableUnique({
          name: _this10.connection.namingStrategy.uniqueConstraintName(table, [column.name]),
          columnNames: [column.name]
        }));
      });
      if (table.uniques.length > 0) {
        var uniquesSql = table.uniques.map(function (unique) {
          var uniqueName = unique.name ? unique.name : _this10.connection.namingStrategy.uniqueConstraintName(newTableName, unique.columnNames);
          var columnNames = unique.columnNames.map(function (columnName) {
            return "\"".concat(columnName, "\"");
          }).join(", ");
          return "CONSTRAINT \"".concat(uniqueName, "\" UNIQUE (").concat(columnNames, ")");
        }).join(", ");
        sql += ", ".concat(uniquesSql);
      }
      if (table.checks.length > 0) {
        var checksSql = table.checks.map(function (check) {
          var checkName = check.name ? check.name : _this10.connection.namingStrategy.checkConstraintName(newTableName, check.expression);
          return "CONSTRAINT \"".concat(checkName, "\" CHECK (").concat(check.expression, ")");
        }).join(", ");
        sql += ", ".concat(checksSql);
      }
      if (table.foreignKeys.length > 0 && createForeignKeys) {
        var foreignKeysSql = table.foreignKeys.filter(function (fk) {
          var _this10$splitTablePat = _this10.splitTablePath(fk.referencedTableName),
            _this10$splitTablePat2 = _slicedToArray(_this10$splitTablePat, 1),
            referencedDatabase = _this10$splitTablePat2[0];
          if (referencedDatabase !== database) {
            return false;
          }
          return true;
        }).map(function (fk) {
          var _this10$splitTablePat3 = _this10.splitTablePath(fk.referencedTableName),
            _this10$splitTablePat4 = _slicedToArray(_this10$splitTablePat3, 2),
            referencedTable = _this10$splitTablePat4[1];
          var columnNames = fk.columnNames.map(function (columnName) {
            return "\"".concat(columnName, "\"");
          }).join(", ");
          if (!fk.name) fk.name = _this10.connection.namingStrategy.foreignKeyName(newTableName, fk.columnNames, _this10.getTablePath(fk), fk.referencedColumnNames);
          var referencedColumnNames = fk.referencedColumnNames.map(function (columnName) {
            return "\"".concat(columnName, "\"");
          }).join(", ");
          var constraint = "CONSTRAINT \"".concat(fk.name, "\" FOREIGN KEY (").concat(columnNames, ") REFERENCES \"").concat(referencedTable, "\" (").concat(referencedColumnNames, ")");
          if (fk.onDelete) constraint += " ON DELETE ".concat(fk.onDelete);
          if (fk.onUpdate) constraint += " ON UPDATE ".concat(fk.onUpdate);
          if (fk.deferrable) constraint += " DEFERRABLE ".concat(fk.deferrable);
          return constraint;
        }).join(", ");
        sql += ", ".concat(foreignKeysSql);
      }
      if (primaryColumns.length > 1) {
        var columnNames = primaryColumns.map(function (column) {
          return "\"".concat(column.name, "\"");
        }).join(", ");
        sql += ", PRIMARY KEY (".concat(columnNames, ")");
      }
      sql += ")";
      if (table.withoutRowid) {
        sql += " WITHOUT ROWID";
      }
      return new Query(sql);
    }
    /**
     * Builds drop table sql.
     */
  }, {
    key: "dropTableSql",
    value: function dropTableSql(tableOrName, ifExist) {
      var tableName = InstanceChecker.isTable(tableOrName) ? tableOrName.name : tableOrName;
      var query = ifExist ? "DROP TABLE IF EXISTS ".concat(this.escapePath(tableName)) : "DROP TABLE ".concat(this.escapePath(tableName));
      return new Query(query);
    }
  }, {
    key: "createViewSql",
    value: function createViewSql(view) {
      if (typeof view.expression === "string") {
        return new Query("CREATE VIEW \"".concat(view.name, "\" AS ").concat(view.expression));
      } else {
        return new Query("CREATE VIEW \"".concat(view.name, "\" AS ").concat(view.expression(this.connection).getQuery()));
      }
    }
  }, {
    key: "insertViewDefinitionSql",
    value: function insertViewDefinitionSql(view) {
      var expression = typeof view.expression === "string" ? view.expression.trim() : view.expression(this.connection).getQuery();
      return this.insertTypeormMetadataSql({
        type: MetadataTableType.VIEW,
        name: view.name,
        value: expression
      });
    }
    /**
     * Builds drop view sql.
     */
  }, {
    key: "dropViewSql",
    value: function dropViewSql(viewOrPath) {
      var viewName = InstanceChecker.isView(viewOrPath) ? viewOrPath.name : viewOrPath;
      return new Query("DROP VIEW \"".concat(viewName, "\""));
    }
    /**
     * Builds remove view sql.
     */
  }, {
    key: "deleteViewDefinitionSql",
    value: function deleteViewDefinitionSql(viewOrPath) {
      var viewName = InstanceChecker.isView(viewOrPath) ? viewOrPath.name : viewOrPath;
      return this.deleteTypeormMetadataSql({
        type: MetadataTableType.VIEW,
        name: viewName
      });
    }
    /**
     * Builds create index sql.
     */
  }, {
    key: "createIndexSql",
    value: function createIndexSql(table, index) {
      var columns = index.columnNames.map(function (columnName) {
        return "\"".concat(columnName, "\"");
      }).join(", ");
      var _this$splitTablePath9 = this.splitTablePath(table.name),
        _this$splitTablePath10 = _slicedToArray(_this$splitTablePath9, 2),
        database = _this$splitTablePath10[0],
        tableName = _this$splitTablePath10[1];
      return new Query("CREATE ".concat(index.isUnique ? "UNIQUE " : "", "INDEX ").concat(database ? "\"".concat(database, "\".") : "").concat(this.escapePath(index.name), " ON \"").concat(tableName, "\" (").concat(columns, ") ").concat(index.where ? "WHERE " + index.where : ""));
    }
    /**
     * Builds drop index sql.
     */
  }, {
    key: "dropIndexSql",
    value: function dropIndexSql(indexOrName) {
      var indexName = InstanceChecker.isTableIndex(indexOrName) ? indexOrName.name : indexOrName;
      return new Query("DROP INDEX ".concat(this.escapePath(indexName)));
    }
    /**
     * Builds a query for create column.
     */
  }, {
    key: "buildCreateColumnSql",
    value: function buildCreateColumnSql(column, skipPrimary) {
      var c = '"' + column.name + '"';
      if (InstanceChecker.isColumnMetadata(column)) {
        c += " " + this.driver.normalizeType(column);
      } else {
        c += " " + this.connection.driver.createFullType(column);
      }
      if (column.enum) c += ' CHECK( "' + column.name + '" IN (' + column.enum.map(function (val) {
        return "'" + val + "'";
      }).join(",") + ") )";
      if (column.isPrimary && !skipPrimary) c += " PRIMARY KEY";
      if (column.isGenerated === true && column.generationStrategy === "increment")
        // don't use skipPrimary here since updates can update already exist primary without auto inc.
        c += " AUTOINCREMENT";
      if (column.collation) c += " COLLATE " + column.collation;
      if (column.isNullable !== true) c += " NOT NULL";
      if (column.asExpression) {
        c += " AS (".concat(column.asExpression, ") ").concat(column.generatedType ? column.generatedType : "VIRTUAL");
      } else {
        if (column.default !== undefined && column.default !== null) c += " DEFAULT (" + column.default + ")";
      }
      return c;
    }
  }, {
    key: "recreateTable",
    value: function () {
      var _recreateTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee61(newTable, oldTable) {
        var _this11 = this;
        var migrateData,
          upQueries,
          downQueries,
          _this$splitTablePath11,
          _this$splitTablePath12,
          databaseNew,
          tableNameNew,
          _this$splitTablePath13,
          _this$splitTablePath14,
          tableNameOld,
          newColumnNames,
          oldColumnNames,
          _args61 = arguments;
        return _regeneratorRuntime().wrap(function _callee61$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              migrateData = _args61.length > 2 && _args61[2] !== undefined ? _args61[2] : true;
              upQueries = [];
              downQueries = []; // drop old table indices
              oldTable.indices.forEach(function (index) {
                upQueries.push(_this11.dropIndexSql(index));
                downQueries.push(_this11.createIndexSql(oldTable, index));
              });
              // change table name into 'temporary_table'
              _this$splitTablePath11 = this.splitTablePath(newTable.name), _this$splitTablePath12 = _slicedToArray(_this$splitTablePath11, 2), databaseNew = _this$splitTablePath12[0], tableNameNew = _this$splitTablePath12[1];
              _this$splitTablePath13 = this.splitTablePath(oldTable.name), _this$splitTablePath14 = _slicedToArray(_this$splitTablePath13, 2), tableNameOld = _this$splitTablePath14[1];
              newTable.name = tableNameNew = "".concat(databaseNew ? "".concat(databaseNew, ".") : "", "temporary_").concat(tableNameNew);
              // create new table
              upQueries.push(this.createTableSql(newTable, true, true));
              downQueries.push(this.dropTableSql(newTable));
              // migrate all data from the old table into new table
              if (migrateData) {
                newColumnNames = newTable.columns.filter(function (column) {
                  return !column.generatedType;
                }).map(function (column) {
                  return "\"".concat(column.name, "\"");
                });
                oldColumnNames = oldTable.columns.filter(function (column) {
                  return !column.generatedType;
                }).map(function (column) {
                  return "\"".concat(column.name, "\"");
                });
                if (oldColumnNames.length < newColumnNames.length) {
                  newColumnNames = newTable.columns.filter(function (column) {
                    var oldColumn = oldTable.columns.find(function (c) {
                      return c.name === column.name;
                    });
                    if (oldColumn && oldColumn.generatedType) return false;
                    return !column.generatedType && oldColumn;
                  }).map(function (column) {
                    return "\"".concat(column.name, "\"");
                  });
                } else if (oldColumnNames.length > newColumnNames.length) {
                  oldColumnNames = oldTable.columns.filter(function (column) {
                    return !column.generatedType && newTable.columns.find(function (c) {
                      return c.name === column.name;
                    });
                  }).map(function (column) {
                    return "\"".concat(column.name, "\"");
                  });
                }
                upQueries.push(new Query("INSERT INTO ".concat(this.escapePath(newTable.name), "(").concat(newColumnNames.join(", "), ") SELECT ").concat(oldColumnNames.join(", "), " FROM ").concat(this.escapePath(oldTable.name))));
                downQueries.push(new Query("INSERT INTO ".concat(this.escapePath(oldTable.name), "(").concat(oldColumnNames.join(", "), ") SELECT ").concat(newColumnNames.join(", "), " FROM ").concat(this.escapePath(newTable.name))));
              }
              // drop old table
              upQueries.push(this.dropTableSql(oldTable));
              downQueries.push(this.createTableSql(oldTable, true));
              // rename old table
              upQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(newTable.name), " RENAME TO ").concat(this.escapePath(tableNameOld))));
              downQueries.push(new Query("ALTER TABLE ".concat(this.escapePath(oldTable.name), " RENAME TO ").concat(this.escapePath(tableNameNew))));
              newTable.name = oldTable.name;
              // recreate table indices
              newTable.indices.forEach(function (index) {
                // new index may be passed without name. In this case we generate index name manually.
                if (!index.name) index.name = _this11.connection.namingStrategy.indexName(newTable, index.columnNames, index.where);
                upQueries.push(_this11.createIndexSql(newTable, index));
                downQueries.push(_this11.dropIndexSql(index));
              });
              // update generated columns in "typeorm_metadata" table
              // Step 1: clear data for removed generated columns
              oldTable.columns.filter(function (column) {
                var newTableColumn = newTable.columns.find(function (c) {
                  return c.name === column.name;
                });
                // we should delete record from "typeorm_metadata" if generated column was removed
                // or it was changed to non-generated
                return column.generatedType && column.asExpression && (!newTableColumn || !newTableColumn.generatedType && !newTableColumn.asExpression);
              }).forEach(function (column) {
                var deleteQuery = _this11.deleteTypeormMetadataSql({
                  table: oldTable.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: column.name
                });
                var insertQuery = _this11.insertTypeormMetadataSql({
                  table: oldTable.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: column.name,
                  value: column.asExpression
                });
                upQueries.push(deleteQuery);
                downQueries.push(insertQuery);
              });
              // Step 2: add data for new generated columns
              newTable.columns.filter(function (column) {
                return column.generatedType && column.asExpression && !oldTable.columns.some(function (c) {
                  return c.name === column.name;
                });
              }).forEach(function (column) {
                var insertQuery = _this11.insertTypeormMetadataSql({
                  table: newTable.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: column.name,
                  value: column.asExpression
                });
                var deleteQuery = _this11.deleteTypeormMetadataSql({
                  table: newTable.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: column.name
                });
                upQueries.push(insertQuery);
                downQueries.push(deleteQuery);
              });
              // Step 3: update changed expressions
              newTable.columns.filter(function (column) {
                return column.generatedType && column.asExpression;
              }).forEach(function (column) {
                var oldColumn = oldTable.columns.find(function (c) {
                  return c.name === column.name && c.generatedType && column.generatedType && c.asExpression !== column.asExpression;
                });
                if (!oldColumn) return;
                // update expression
                var deleteQuery = _this11.deleteTypeormMetadataSql({
                  table: oldTable.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: oldColumn.name
                });
                var insertQuery = _this11.insertTypeormMetadataSql({
                  table: newTable.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: column.name,
                  value: column.asExpression
                });
                upQueries.push(deleteQuery);
                upQueries.push(insertQuery);
                // revert update
                var revertInsertQuery = _this11.insertTypeormMetadataSql({
                  table: newTable.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: oldColumn.name,
                  value: oldColumn.asExpression
                });
                var revertDeleteQuery = _this11.deleteTypeormMetadataSql({
                  table: oldTable.name,
                  type: MetadataTableType.GENERATED_COLUMN,
                  name: column.name
                });
                downQueries.push(revertInsertQuery);
                downQueries.push(revertDeleteQuery);
              });
              _context61.next = 21;
              return this.executeQueries(upQueries, downQueries);
            case 21:
              this.replaceCachedTable(oldTable, newTable);
            case 22:
            case "end":
              return _context61.stop();
          }
        }, _callee61, this);
      }));
      function recreateTable(_x96, _x97) {
        return _recreateTable.apply(this, arguments);
      }
      return recreateTable;
    }()
    /**
     * tablePath e.g. "myDB.myTable", "myTable"
     */
  }, {
    key: "splitTablePath",
    value: function splitTablePath(tablePath) {
      return tablePath.indexOf(".") !== -1 ? tablePath.split(".") : [undefined, tablePath];
    }
    /**
     * Escapes given table or view path. Tolerates leading/trailing dots
     */
  }, {
    key: "escapePath",
    value: function escapePath(target, disableEscape) {
      var tableName = InstanceChecker.isTable(target) || InstanceChecker.isView(target) ? target.name : target;
      return tableName.replace(/^\.+|\.+$/g, "").split(".").map(function (i) {
        return disableEscape ? i : "\"".concat(i, "\"");
      }).join(".");
    }
  }]);
  return AbstractSqliteQueryRunner;
}(BaseQueryRunner);